import { memo, useRef } from 'react'
import PropTypes from 'prop-types'
import { motion } from 'framer-motion'
import { maxBy } from 'lodash'

import { useResize } from 'reactUtils/hooks/use-resize'
import { formatters } from 'reactUtils/formatters'

import { Icon } from 'lmcv/components/Icon'

import { TimeLineSkeleton } from './TimeLineSkeleton'
import { decimalToPercent } from './helpers'
import * as S from './styled'

function TimeLine ({ data, isLoading }) {
  const [isMobile] = useResize()

  const maxGoal =
    !isLoading && parseInt(maxBy(data.prizes, data => data.goal).goal, 10)

  const constraintsRef = useRef(null)

  return (
    <S.Wrapper as={motion.div} ref={constraintsRef}>
      <S.DragArea
        width={1000}
        as={motion.div}
        drag="x"
        dragConstraints={{
          left: isMobile ? -750 : -200,
          right: 0
        }}
        whileTap={{ cursor: 'grabbing' }}
      >
        {isLoading
          ? (<TimeLineSkeleton />)
          : (
            <S.Bar width={1000}>
              {data.prizes.map(({ id, goal, reward }) => (
                <S.Item
                  key={id}
                  toLeft={decimalToPercent(goal, maxGoal)}
                  isGoal={data.points.seasonBalance >= goal}
                >
                  <S.Ballon>+ {formatters.toDecimal(reward)} pts</S.Ballon>
                  <S.Label>{formatters.toCurrency(goal)}</S.Label>
                </S.Item>
              ))}

              <S.BarProgress
                progress={decimalToPercent(data.points.seasonBalance, maxGoal)}
                value={formatters.toCurrency(data.points.seasonBalance)}
              />
            </S.Bar>
            )}
      </S.DragArea>
    </S.Wrapper>
  )
}

TimeLine.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool
}

export default memo(TimeLine)
